import { motion } from "framer-motion";

const steps = [
  {
    step: "01",
    title: "Connect Your Companies",
    text: "Securely link each QuickBooks Online account in a few clicks — no spreadsheets, no manual data entry, no IT ticket required.",
  },
  {
    step: "02",
    title: "Group & Consolidate",
    text: "Organize entities into reporting groups, choose cash or accrual basis, and toggle combined or month-over-month views instantly.",
  },
  {
    step: "03",
    title: "Export Board-Ready Reports",
    text: "Generate polished Balance Sheets, P&Ls, Cash Flow, and Trial Balance reports — view them on screen or export to Excel in one click.",
  },
];

function HowItWorks() {
  return (
    <section id="how" className="how-section">
      <div className="how-inner">
        <span className="section-eyebrow">How It Works</span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          From messy books to board-ready reports
        </motion.h2>
        <p className="how-subtitle">
          Three steps stand between your QuickBooks data and a clean,
          consolidated report your whole team can trust.
        </p>

        <div className="how-steps">
          {steps.map((s, i) => (
            <motion.div
              key={s.step}
              className="how-step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.12, duration: 0.6, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <div className="how-step-number">{s.step}</div>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
              {i < steps.length - 1 && <div className="how-step-connector" />}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
